import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import hocScrollbar from 'gnos-scrollbar'
import config from '@config'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

const version = window.version ? window.version : config.versionNumber

@hocScrollbar({ smoothScrollbar: true })
@hocConnect
export default class Content extends Component {
    static propTypes = {
        license: PropTypes.object.isRequired,
    }

    render() {
        const { license } = this.props

        return (
            <div className={'about-content-wrapper'}>
                <div className={'about-content'}>
                    <br />
                    <div className={'row d-flex justify-content-between'}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.text.platform`}
                            values={{ versionNumber: version, b: (chunks) => <b>{chunks}</b> }}
                        />
                        <a
                            href={'https://www.dnb.com/cs-cz/produkty/gnosus/'}
                            className={'link'}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.link.more`} />
                        </a>
                    </div>
                    <br />
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.text.license`}
                        values={{ license: license.name, b: (chunks) => <b>{chunks}</b> }}
                    />
                    <hr />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.publisher`} />
                    <br />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.authors`} />
                    <hr />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.header`} />
                    <br />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.processor`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.ram`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.space`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.gpu`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.devices`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.software`} />
                    <br />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.js`} />
                    <br />
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.text.requirements.export`}
                        values={{
                            a: (chunks) => (
                                <a
                                    className="link"
                                    href="https://get.adobe.com/cz/reader/otherversions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.certificate`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.ports`} />
                    <br />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.requirements.protocols`} />
                    <hr />
                    <FormattedMessage id={`${LOCALE_PREFIX}.text.copyright`} />
                    <br />
                    <br />
                    <div className={'row d-flex'}>
                        <a
                            href={'https://www.dnb.com/cs-cz/'}
                            className={'link'}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.link.bisnodeWeb`} />
                        </a>
                        <span className={'spacer'}>|</span>
                        <a href={'mailto:podpora.cz@dnb.com'} className={'link'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.link.customerService`} />
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
